<template>
  <div
    id="header_mobile"
    ref="header_mobile"
    class="header-mobile header-mobile-fixed"
    v-bind:class="headerClasses"
  >
  <button
        class="btn p-0 burger-icon ml-4"
        id="header_mobile_toggle"
        ref="header_mobile_toggle"
      >
        <span> </span>
      </button>
    <router-link to="/">
      <img
        alt="Logo"
        src="/media/svg/logos/logo.svg" 
        class="logo-default max-h-30px"
      />
    </router-link>

    <div class="d-flex align-items-center">
      <button
        class="btn btn-hover-text-primary p-0 ml-2"
        id="header_mobile_topbar_toggle"
        ref="header_mobile_topbar_toggle"
      >
        <span class="svg-icon svg-icon-xl">
          <inline-svg src="/media/svg/icons/General/User.svg" />
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import LayoutHeaderTopBar from "@/assets/js/layout/base/header-topbar.js";

export default {
  name: "HeaderMobile",
  components: {},
  mounted() {
    LayoutHeaderTopBar.init(this.$refs["header_mobile_topbar_toggle"]);
  },
  computed: {
    ...mapGetters(["getClasses", "layoutConfig"]),
    headerClasses() {
      const classes = this.getClasses("header_mobile");

      if (typeof classes !== "undefined") return classes.join(" ");

      return null;
    },
  },
};
</script>
